import { render } from "./StepOptions.vue?vue&type=template&id=06aba930&scoped=true"
import script from "./StepOptions.vue?vue&type=script&lang=js"
export * from "./StepOptions.vue?vue&type=script&lang=js"

import "./StepOptions.vue?vue&type=style&index=0&id=06aba930&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06aba930"]])

export default __exports__